import { useParams } from "react-router-dom";
import OrderDiscount from "./OrderDiscount";
import Layout from "../../components/layout";
import Header from "../../components/header";
import React, { useEffect, useMemo } from "react";
import { useCommonApi } from "../../store/api/hooks/commonApiHook";
import { useDiscountsApi } from "../../store/api/hooks/discountsApiHook";
import { useAppLoader } from "../../_common/pageLoader/appLoaderHook";
import toast from "react-hot-toast";
import ProductDiscount from "./Product Discount";
import BuyXGetYDiscount from "./BuyXGetYDiscount";
import { useCustomersApi } from "../../store/api/hooks/customersApiHook";
import CreateProductDiscount from "./Product Discount/CreateProductDiscount";
import Permission, { hasPermission } from "../../_config/Permission";
import { useMenuPermissionsSelector } from "../../store/selectors/userSelector";
import { URLS } from "../../_config";
import { useTranslation } from "react-i18next";

const CreateDiscount: React.FC = () => {
  const { t } = useTranslation("discounts");
  const { type, id } = useParams();
  const allPermissions = useMenuPermissionsSelector();
  const permissionData = useMemo(() => allPermissions?.[URLS.DISCOUNT] || null, [allPermissions]);
  const commonApi = useCommonApi();
  const customerApi = useCustomersApi();
  const discountApi = useDiscountsApi();
  const { showLoader, hideLoader } = useAppLoader();
  const [discountx, setDiscountx] = React.useState<any>(null);
  const [isRender, setIsRender] = React.useState<boolean>(false);

  const ini_page_data = async () => {
    setIsRender(false);
    if (id) {
      showLoader();
      const discountresp: any = await new Promise((resolve, reject) =>
        discountApi.searchDiscount({ discountId: id }, resolve, reject)
      ).catch((err) => null);
      if (
        discountresp &&
        discountresp.hasOwnProperty("success") &&
        discountresp.success === true &&
        discountresp?.data &&
        discountresp.data &&
        discountresp.data.hasOwnProperty(`items`) &&
        Array.isArray(discountresp.data.items) &&
        discountresp.data.items.length > 0
      ) {
        setDiscountx(discountresp.data.items[0]);
        console.log("Fetched", discountresp.data.items[0]);
        setIsRender(true);
      } else {
        toast.error(
          discountresp?.errorMessage || t("createDiscount.toasts.fetchFailed")
        );
      }
      hideLoader();
    } else {
      setIsRender(true);
    }
  };

  useEffect(() => {
    ini_page_data();
    commonApi.locationSearch(
      {},
      () => {},
      (error: any) => {
        console.log("Locations load error:", error);
      }
    );
    customerApi.listCustomerGroups(
      {},
      () => {},
      (error: any) => {
        console.log("Customer groups load error:", error);
      }
    );
  }, []);

  return (
    <Layout manualNavigationBlocked={hasPermission(permissionData, "W")} alertMessageForBeforeUnload={t("createDiscount.unsavedChangesWarning")}>
      <Header />
      <Permission value={permissionData} check="W" page={true}>
      {isRender && (
        <div>
          {(() => {
            switch (type?.toUpperCase()) {
              case `MTM3`:
                return (
                  <OrderDiscount
                    type={type.toUpperCase()}
                    discount={discountx}
                  />
                );
              case `MTM0`:
              case `MTM1`:
                return (
                  <ProductDiscount
                    type={type.toUpperCase()}
                    discount={discountx}
                  />
                );
              case `MTM2`:
                return (
                  <BuyXGetYDiscount
                    type={type.toUpperCase()}
                    discount={discountx}
                  />
                );
              case `PRODUCT-DISCOUNT`:
                return (
                  <CreateProductDiscount />
                );
              default:
                return <p>{t("createDiscount.fallback")}</p>;
            }
          })()}
        </div>
      )}
      </Permission>
    </Layout>
  );
};

export default CreateDiscount;
